import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Button } from "../ui/Button"
import { Dialog } from "@/components/ui/Dialog"

import { popDialog } from "@/store/dialogs-state"
import { toSnakeCase } from "@/utils/string"

export const InputDialog = (props: {
	title: string
	buttonTitle: string
	initialInput: string
	trackingViewName: string
	buttonTrackingLabel?: string
	confirmWithEnter?: boolean
	onConfirm: (string) => void
}) => {
	const { t } = useTranslation("components")
	const [input, setInput] = useState(props.initialInput)

	return (
		<Dialog trackingViewName={props.trackingViewName} contentSize="sm-h-auto" disableClose>
			<div className="flex w-full flex-col space-y-4">
				<div className="text-start text-md font-bold">{props.title}</div>
				<input
					className="rounded p-1.5 text-sm"
					value={input}
					onChange={(e) => {
						setInput(e.target.value)
					}}
				/>
				<div className="flex w-full flex-1 flex-row items-center justify-end space-x-2">
					<Button trackingLabel="cancel" onClick={() => popDialog()}>
						{t("common:action.cancel")}
					</Button>
					<Button
						trackingLabel={props.buttonTrackingLabel ?? toSnakeCase(props.buttonTitle)}
						trackingValue={input}
						disabled={input.length < 1}
						onClick={() => {
							props.onConfirm(input)
						}}
						variant="primary"
					>
						{props.buttonTitle}
					</Button>
				</div>
			</div>
		</Dialog>
	)
}
